import { ConfigFn } from '@config/types'

const config = (({ staticAssetPageUrl, staticPageUrlSuffix }) =>
  ({
    widgetUrl: `${staticAssetPageUrl}/financeScout${staticPageUrlSuffix}`,
    allowedOrigins: [
      'https://krankenkasse.financescout24.ch',
      'https://health-insurance-frontend.test.financescout24.ch',
    ],
  }) as const) satisfies ConfigFn

export default config
